import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareCalendarCustomEmbedRoute } from '@atlassian/jira-router-routes-software-calendar-routes/src/softwareCalendarCustomEmbedRoute.tsx';
import { CalendarEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/calendar/CalendarSkeleton.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { aiEntitlementResource } from '@atlassian/jira-router-resources-ai-entitlement/src/services/index.tsx';
import { calendarRouteEntry } from './common/calendarRouteEntry.tsx';

export const softwareCalendarCustomEmbedRouteEntry = createEntry(
	softwareCalendarCustomEmbedRoute,
	() => ({
		group: 'software',
		skeleton: CalendarEmbedSkeleton,
		component: CalendarEmbedSkeleton,
		entryPoint() {
			return calendarRouteEntry;
		},
		layout: chromelessLayout,
		resources: [
			themePreferenceResource,
			resourceWithCondition2(() => fg('ai_sprint_goal_gate'), aiEntitlementResource),
		],
		ufoName: 'next-gen-calendar-embed',
		EXPERIMENTAL__shouldReload: fg('jira_fix_calendar_suspending_when_switching_months')
			? ({ context, prevContext }) => {
					return context.match.url !== prevContext.match.url;
				}
			: undefined,
	}),
);
